<!--
 * @Author: your name
 * @Date: 2021-05-10 18:01:20
 * @LastEditTime: 2021-07-28 10:28:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \莅视pc端\SurgicalCommunication\src\pages\BaseDoctorPage.vue
-->
<template>
    <div class="base_doctor_page">
        <div class="team_item" v-for="(item) in teamList" :key="item.CenterID" 
        :style="{borderBottom:item.CenterID == id ? '1px dotted #1890FF' : '1px dotted transparent'}"
        :title="item.CenterID == id1 ? '你的团队' : item.Team"
        @mouseenter="enter(item)"
        @mouseleave="leave(item)"
        >
        <div class="corner" v-if="item.IsJoin!==null" :style="{background:item.IsJoin == 'T' ? '#1890FF' : '#DED9BB'}">{{item.IsJoin == 'T' ?"已加入":"已申请"}}</div>
            <div class="head">
                {{item.Team}}
            </div>
            <div class="content">
                {{item.Introduction ? item.Introduction : "暂时没有介绍~"}}
            </div>
            <div class="btn_box">
                <Button type="primary" @click="lookMember(item)">查看团队成员</Button>
                <Button type="primary" @click="startDis(item)">发起案例讨论</Button>
            </div>
        </div>
        <Modal
            title="提示"
            v-model="modal"
            class-name="modals"
        >
            <p>向该中心发起案例，需要提交加入申请，是否确定现在提交</p>
            <div slot="footer">
                <Button size="large" @click="modal = false">取消</Button>
                <Button size="large" @click="sendDiscuss">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import Request from "../utils/request";
import config from "../config/index.js";
import { Button,Modal, } from 'view-design'
export default {
    components: {
        Button,
        Modal,
    },
    data() {
        return {
            id:0,
            id1:0,
            teamList:[{}],
            timer:null,
            modal:false,
            info:{},
        };
    },
    methods: {
        enter(row){
            clearInterval(this.timer)
            this.id = row.CenterID
        },
        leave(row){
            this.id = row.CenterID
            this.timer = setInterval(()=>{
                this.id = JSON.parse(window.localStorage.getItem('Role')).CenterID
            },1000)
        },
        //查看团队成员
        lookMember(row){
            this.$store.commit({
            type:'changeInfo',
            payload:{
                team:row.Team,
                teamID:row.CenterID,
                intro:row.Introduction,
                isJoin:row.IsJoin,
                centerName:row.CenterName,
                centerID:row.CenterID,
                }
            })
            this.$router.push('/HomePage/ExpertTeamInformation')
        },
        //发起案例讨论 对话框
        startDis(row){
            if(row.IsJoin == null){
                /* 如果还未申请 就弹出对话框 选择是否发起申请 */
                this.info = row
                this.modal = true
            }else{
                if(row.IsJoin == 'T'){
                /* 如果申请过 并且 通过的话 存一下变量跳转页面*/
                    this.$store.commit({
                    type:'edit',
                    payload:{
                        team:row.Team,
                        teamID:row.CenterID,
                        type:1,
                        IsJoin:row.IsJoin,
                    }
                })
                    this.$router.push('/HomePage/NewCase')
                }else if(row.IsJoin == 'F'){
                    /* 不能申请了*/
                    this.$Message['info']({
                        background: true,
                        content: '您已向团队发起申请，请耐心等待审核'
                    })
                }
            }
        },
        //发起讨论
        sendDiscuss(){
            this.modal = false
            Request.postRequest(config.SXG_baseUrl+"/api/docmanager/SaveDocCenter",{
                    tablename:"DocCenter",//表名 DocCenter
                    CenterName:this.info.CenterName,
                    CenterID:this.info.CenterID,
                    UserJid:JSON.parse(window.localStorage.getItem('Role')).UserJid,
                    DocName:JSON.parse(window.localStorage.getItem('Role')).DocName,
                    DLID:JSON.parse(window.localStorage.getItem('Role')).ID,//医生表（Role）的 ID
                    Sex:JSON.parse(window.localStorage.getItem('Role')).Sex,
                    Cellphone:JSON.parse(window.localStorage.getItem('Role')).Cellphone,
                    Age:JSON.parse(window.localStorage.getItem('Role')).Age,
                    HospitalName:JSON.parse(window.localStorage.getItem('Role')).HospitalName,
                    DepartmentName:JSON.parse(window.localStorage.getItem('Role')).DepartmentName,
                }).then((res)=>{
                    if(res.code == 200){
                        this.$Message.info("成功！")
                        this.$router.go(0)
                    }
                })
        },
        /* 获取团队列表 */
        getTeamList(){
            Request.getRequest(config.SXG_baseUrl+"/api/docmanager/GetCenterList",{
                // CenterID: JSON.parse(localStorage.getItem("Role")).CenterID
                UserJid:JSON.parse(localStorage.getItem("Role")).UserJid
            }).then((res)=>{
                // console.log(res)
                if(res.code == 200){
                    // res.data.map(item=>{
                    //     this.teamList.push(item)
                    // })
                    this.teamList = res.data
                    this.$nextTick(()=> {
                        console.log(this.teamList)
                    });
                }
            })
        }
    },
    created() {
        this.id = JSON.parse(window.localStorage.getItem('Role')).CenterID
        this.id1 = JSON.parse(window.localStorage.getItem('Role')).CenterID
        this.$emit("funChangeTitle", "首页", "1");
    },
    mounted() {
        this.getTeamList()
        this.$Message.config({
            // top: 200,
            duration: 3
        })
    },
    beforeRouteLeave(to, form, next) {
        window.clearInterval()
        next()
  }
}
</script>
<style lang='less'>
    .base_doctor_page{
        padding-right: 15px;
        background:#F3F5F7;
        width:100%;
        height:100%;
        overflow: auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: flex-start;
        align-content: flex-start;
        .team_item{
            width:47%;
            height:263px;
            padding:55px 33px 0 33px;
            border-top:1px solid #E9E9E9;
            border-bottom:1px solid #E9E9E9;
            margin-bottom:40px;
            background:#fff url(../assets/team.png) no-repeat right 20px top 15px;
            transition: all 0.3s;
            position: relative;
            .corner{
                width: 70px;
                height: 35px;
                text-align: center;
                line-height: 35px;
                color: #fff;
                position: absolute;
                top: 0;
                right: 0;
                font-weight: 500;
                letter-spacing: 2px;
                border-bottom-left-radius: 15px;
                transition: all 0.3s;
            }
            .head{
                font-size:20px;
                font-weight: 700;
                color:#000;
            }
            .content{
                margin-top:15px;
                height:100px;
                width:100%;
                overflow: auto;
                word-wrap: break-word;
            }
            .btn_box{
                margin-top:10px;
               button:first-child{
                   margin-right:33px;
                   padding: 5px;
               }
            }
        }
    }
    .modals{
            display: flex;
            align-items: start;
            justify-content: center;
            top:200px;
            .ivu-modal{
                width: 350px!important;
            }
            .ivu-modal-header-inner{
                text-align: center;
                font-weight: 800;
                font-family: "Microsoft Yahei";
            }
            .ivu-modal-header{
                border-bottom: none;
            }
            .ivu-modal-body{
                padding:8px 50px 16px 50px;
                word-break:break-all;
            }
            .ivu-modal-footer{
                padding: 0;
                div{
                    text-align: center;
                    // border-top: none;
                    display: flex;
                    padding: 0;
                }
                .ivu-btn{
                    width: 50%;
                    height: 50px;
                    border-top-left-radius: 0px;
                    border-top-right-radius: 0px;
                    background: #fff;
                    border: none;
                    color: #6F78F7;
                    font-size: 16px;
                }
                .ivu-btn:nth-child(1){
                    border-right: 1px solid #eee;
                }
            }
            .ivu-icon-ios-close:before{
                display: none;
            }
        }
</style>